import { HubConnection } from '@microsoft/signalr';
import { typeControl } from './types.analitos';

/** Estructura para la respuesta HTTP */
export interface HTTPResponse {
  /**
   * Código http generado por la api
   */
  httpCode: number;

  /**
   * Código interno de proceso, Entre 1 y 19 códigos de éxito y mayor a 20 códigos de error
   */
  internalCode: number;

  /**
   * Indica si es success = éxito, error = error, Undefinded = No definido
   */
  messageHeader: string | null;

  /**
   * Mensaje descriptivo del resultado
   */
  message: string;

  /**
   * En caso de que hayan advertencias en la ejecución de un proceso
   */
  warnings: string | null;

  /**
   * Detalles de la ejecución o detalle del error. Exception
   */
  messageDetails: any | null; // Usa el tipo más adecuado si conoces la estructura específica de messageDetails.

  /**
   * Información de retorno útil para quien consume, respuestas, data, entre otros...
   */
  data: any | null; // Usa el tipo más adecuado si conoces la estructura específica de data.
}

export type SignalRStates = {
  DataChangeId: string | null;
  DataChangeIsconnected: boolean;
  DataSusriptions: string[];
  ErrorData: string;
  Notifycations: HubConnection | undefined;
  NotifycationsSusriptions: string[];
  ErrorNotifications: string;
};

export type FormField = {
  label: string;
  type: typeControl;
  typeCondition?: '=' | '!=' | '>' | '<' | '>=' | '<=' | 'between';
  equivalence: string;
  Combobox?: number | null; // ID del combobox
  value: any;
  required: boolean;
  min?: number | string;
  max?: number | string;
  order: number;
  mask?: string;
};

export interface CustomFilters {
  Field: string;
  TypeFilter: TypeTableFilter;
  Value: any;
  Value2?: any;
  Key?: string;
}

export interface Config {
  apiUrl: string;
  singnalRUrl: string;
}

export enum TypeTableFilter {
  Equal = 0,
  NotEqual = 1,
  Contains = 2,
  Between = 3,
  LessThan = 4,
  GreaterThan = 5,
  IN = 6,
}

export interface MenuPpal {
  path: string;
  text: string;
  icon: any;
  items?: SubMenuPpal[];
  permission?: string;
  module?: string;
  fechaLanzamiento?: string; // Fecha de inicio para mostrar como "Nuevo" (formato: YYYY-MM-DD)
  fechaFin?: string; // Fecha de fin para dejar de mostrar como "Nuevo" (formato: YYYY-MM-DD)
}
export interface SubMenuPpal {
  path: string;
  text: string;
  permission?: string;
  module?: string;
  fechaLanzamiento?: string; // Fecha de inicio para mostrar como "Nuevo" (formato: YYYY-MM-DD)
  fechaFin?: string; // Fecha de fin para dejar de mostrar como "Nuevo" (formato: YYYY-MM-DD)
}

export interface DynamicFields {
  Equivalencia: string;
  Valor: string;
}

export interface Traceability {
  filters: CustomFilters[];
}

export type contextPatient = 'orders' | 'quotations' | 'appointment' | 'preorders' | 'externalRemisions' | 'none';
